import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: '首页', to: '/' },
  { label: '奇幻漫画', to: '/fantasy' },
  { label: '校园漫画', to: '/campus' },
  { label: '恋爱漫画', to: '/romance' },
  { label: '关于我们', to: '/about' },
  { label: '常见问题', to: '/faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const isHome = pathname === '/';
  const dark = isHome && !scrolled;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        dark
          ? 'bg-transparent'
          : scrolled
            ? 'bg-background-50/90 shadow-sm backdrop-blur'
            : 'bg-background-50'
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-6">
        <Link to="/" className="flex items-center gap-2" aria-label="韩漫漫画网首页">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-xl text-lg ${
              dark ? 'bg-background-50 text-primary-600' : 'bg-primary-500 text-background-50'
            }`}
          >
            <i className="ri-book-open-line" />
          </span>
          <span className={`font-heading text-xl ${dark ? 'text-background-50' : 'text-foreground-950'}`}>
            韩漫漫画网
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((item) => {
            const active = item.to === pathname;
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`rounded-full px-4 py-2 text-sm transition-colors whitespace-nowrap ${
                  active
                    ? 'bg-primary-500 text-background-50'
                    : dark
                      ? 'text-background-100 hover:bg-background-50/20'
                      : 'text-foreground-700 hover:bg-primary-50 hover:text-primary-600'
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-full md:hidden ${
            dark ? 'text-background-50' : 'text-foreground-900'
          }`}
        >
          <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((item) => {
              const active = item.to === pathname;
              return (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`rounded-lg px-4 py-2.5 text-sm ${
                    active ? 'bg-primary-50 text-primary-600' : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </header>
  );
}